import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

interface HelpTooltipProps {
  text: string;
}

export const HelpTooltip = ({ text }: HelpTooltipProps) => (
  <Tooltip title={text} placement="top">
    <QuestionCircleOutlined
      style={{
        marginLeft: 6,
        color: '#8c8c8c',
        cursor: 'help',
        fontSize: 14,
      }}
    />
  </Tooltip>
);

interface LabelWithHelpProps {
  label: string;
  help: string;
}

export const LabelWithHelp = ({ label, help }: LabelWithHelpProps) => (
  <span>
    {label}
    <HelpTooltip text={help} />
  </span>
);

interface SectionTitleProps {
  title: string;
  help: string;
}

export const SectionTitle = ({ title, help }: SectionTitleProps) => (
  <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    {title}
    <HelpTooltip text={help} />
  </span>
);
